import './BadgeWithNotification.scss';
import {FmlxIcon} from 'fmlx-common-ui';

const NotificationBadge = ({clickHandler}) => {
  return (
    <div className="fmlx-badge-story-show-hide">
      <div onClick={clickHandler} className="fmlx-badge-story-icon">
        <FmlxIcon id="icon-message" customColor="{string}" name="Nt8SendMessage"/>
        <p style={{fontSize: '12px', position: 'relative', right: '10px'}}>Message</p>
      </div>
    </div>
  );
};

export default NotificationBadge;
